/* eslint-disable consistent-return */
import { useContext, useEffect } from 'react';

import * as T from 'prop-types';

import { AuthContext } from '../../../contexts/auth';
import useGoogleTagManager from '../../../hooks/use-google-tag-manager';
import useHotjar from '../../../hooks/use-hotjar';
import useWootric from '../../../hooks/use-wootric';

const PageLayoutNoSupport = ({ children }) => {
  const { setIsGtmLoaded, userInfo } = useContext(AuthContext);
  const { isLoaded } = useGoogleTagManager(userInfo);

  useHotjar(userInfo);

  useWootric(['NPS response'], userInfo);

  useEffect(() => {
    if (isLoaded) {
      setIsGtmLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded]);

  return <main>{children}</main>;
};

PageLayoutNoSupport.propTypes = {
  children: T.node.isRequired,
};

export default PageLayoutNoSupport;
